<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import type { TLCheckbox } from '~/types/formkit-custom'

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext<string> & TLCheckbox>,
    default: null
  }
})

const getId = () => {
  return `form-checkbox-${props.context.name}-${props.context.label}`
}

const handleInput = () => {
  props.context.node.input(!props.context.value)
}
</script>

<template>
  <div class="form-checkbox">
    <input
      :id="getId()"
      type="checkbox"
      :checked="props.context.checked"
      :name="props.context.name"
      @keydown.enter.prevent="handleInput"
      @input="handleInput"
    >

    <div class="form-checkbox-box clickable">
      <CommonIconCheck />
    </div>

    <span>{{ props.context.text }}</span>
  </div>
</template>

<style lang="scss" scoped>
$checkboxSize: 20px;

.form-checkbox {
  display: flex;
  gap: 12px;
  position: relative;
  /* background-color: var(--bgMedium); */
  padding: 3px;
  border-radius: 7px;
  margin-bottom: 10px;

  &-box {
    border: 1px solid rgb(190, 190, 190);
    border-radius: 5px;
    height: $checkboxSize;
    width: $checkboxSize;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    z-index: 10;
    pointer-events: none;
    position: relative;
    flex-shrink: 0;

    svg {
      $innerSize: 65%;
      height: $innerSize;
      width: $innerSize;
      fill: transparent;
    }
  }

  &-box::after {
    $afterSize: -2px;
    content: '';
    position: absolute;
    top: $afterSize;
    bottom: $afterSize;
    right: $afterSize;
    left: $afterSize;
    border-radius: 7px;
    border: 1px solid transparent;
  }

  input {
    border: none;
    outline: none;
    box-shadow: none;
    position: absolute;
    height: 100%;
    width: $checkboxSize;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
    cursor: pointer !important;

    &:checked {
      ~ .form-checkbox-box {
        background-color: var(--purple);
        border-color: var(--purple);

        svg {
          /* fill: var(--purple); */
          fill: white;
        }
      }
    }

    &:focus {
      ~ .form-checkbox-box::after {
        border-color: var(--purple);
      }
    }
  }

  span {
    margin-top: -1px;
    font-size: 0.95rem;
    display: block;
    text-align: left;
    user-select: none;
    line-height: 1.4rem;
  }
}

@media (hover: hover) {
  .form-checkbox:hover {
    /* background-color: #e6ebf5; */
    background-color: var(--bgLight);
  }
}
</style>
